import React from 'react';
import Modal from 'react-bootstrap/Modal';
import ProgressBar from 'react-bootstrap/ProgressBar';


const ProgressModal = ({ show, selectedFile, onClose }) => {
  if (!show || !selectedFile) {
    // Return null or some other placeholder content when selectedFile is null or show is false.
    return null;
  }

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>File Upload Progress</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Uploading: {selectedFile.name}</p>
        <ProgressBar animated now={50} label="Uploading..." />
      </Modal.Body>
      <Modal.Footer>
        {/* You can add a "Done" button or other controls here */}
      </Modal.Footer>
    </Modal>
  );
};

export default ProgressModal;
